import styled from 'styled-components';

import { FlexContainer } from '@legacy/moon/Layout';

const WrapperLoader = styled(FlexContainer)`
  width: 100%;
  height: 100%;
  padding: 1rem;
  flex-direction: column;
  justify-content: center;
`;

export default WrapperLoader;
